import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { api } from "../../api/client";
import { useAuth } from "../../contexts/AuthContext";
import { BottomSheet } from "./BottomSheet";
import { ConfirmDialog } from "./ConfirmDialog";
import { ApiTokensDialog } from "../sheets/ApiTokensDialog";

export function AccountMenu() {
  const { user, clear } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [withdrawOpen, setWithdrawOpen] = useState(false);
  const [tokensOpen, setTokensOpen] = useState(false);

  const logoutMutation = useMutation({
    mutationFn: api.auth.logout,
    onSuccess: () => {
      clear();
      navigate("/login", { replace: true });
    },
  });

  const withdrawMutation = useMutation({
    mutationFn: api.auth.withdraw,
    onSuccess: () => {
      clear();
      navigate("/login", { replace: true });
    },
  });

  if (!user) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="px-3 py-1 text-sm font-medium text-slate-700 hover:bg-slate-100 rounded-lg min-h-[36px]"
      >
        {user.name}
      </button>

      <BottomSheet open={open} onClose={() => setOpen(false)} title={user.name}>
        <div className="px-4 pb-2 -mt-1 text-xs text-slate-500">{user.email}</div>
        <ul className="divide-y divide-slate-100">
          <li>
            <button
              type="button"
              onClick={() => {
                setOpen(false);
                setTokensOpen(true);
              }}
              className="w-full text-left px-4 py-3.5 min-h-[48px] active:bg-slate-100 text-slate-900"
            >
              MCP 토큰
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={() => {
                setOpen(false);
                logoutMutation.mutate();
              }}
              className="w-full text-left px-4 py-3.5 min-h-[48px] active:bg-slate-100 text-slate-900"
            >
              로그아웃
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={() => {
                setOpen(false);
                setWithdrawOpen(true);
              }}
              className="w-full text-left px-4 py-3.5 min-h-[48px] active:bg-slate-100 text-rose-600"
            >
              회원 탈퇴
            </button>
          </li>
        </ul>
        <div className="h-2" />
      </BottomSheet>

      <ApiTokensDialog open={tokensOpen} onClose={() => setTokensOpen(false)} />

      <ConfirmDialog
        open={withdrawOpen}
        onClose={() => setWithdrawOpen(false)}
        onConfirm={() => withdrawMutation.mutate()}
        title="정말 탈퇴하시겠어요?"
        message={`본인이 owner인 모든 plan과 일정·코멘트가 삭제됩니다.\n이 작업은 되돌릴 수 없습니다.`}
        confirmLabel="탈퇴"
        destructive
      />
    </>
  );
}
